var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    clipPath: "url(#clip0_415_332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0833 3.6665H3.66659C3.18036 3.6665 2.71404 3.85966 2.37022 4.20347C2.02641 4.54729 1.83325 5.01361 1.83325 5.49984V18.3332C1.83325 18.8194 2.02641 19.2857 2.37022 19.6295C2.71404 19.9733 3.18036 20.1665 3.66659 20.1665H16.4999C16.9861 20.1665 17.4525 19.9733 17.7963 19.6295C18.1401 19.2857 18.3333 18.8194 18.3333 18.3332V11.9165",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9583 2.29171C17.3229 1.92704 17.8175 1.72217 18.3333 1.72217C18.849 1.72217 19.3436 1.92704 19.7083 2.29171C20.0729 2.65638 20.2778 3.15099 20.2778 3.66671C20.2778 4.18244 20.0729 4.67704 19.7083 5.04171L10.9999 13.75L7.33325 14.6667L8.24992 11L16.9583 2.29171Z",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.378c2773e64eab804c395df95ea35445.svg";
export { ForwardRef as ReactComponent };